"use client";

import React, { useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const steps = [{
  id: "step-0",
  title: "1. Consultation",
  description: "We begin with an intimate conversation at our estate to understand your aesthetic vision, guest requirements, and the unique story you wish to tell.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_wedding_consultation.png"
}, {
  id: "step-1",
  title: "2. Design",
  description: "Our creative team curates a bespoke design palette, selecting textures, florals, and architectural layouts that transform our venue into your personal sanctuary.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_venue_design.png"
}, {
  id: "step-2",
  title: "3. Logistics",
  description: "From high-end catering coordination to seamless vendor management, we handle every technical detail so you can remain present in the moment.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_wedding_logistics.png"
}, {
  id: "step-3",
  title: "4. Celebration",
  description: "The culmination of our journey together. Experience a flawless execution where every element aligns to create an unforgettable, timeless wedding day.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/vow_wedding_celebration.png"
}];
export default function ThePlanningJourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [activeStep, setActiveStep] = useState(steps[0].id);
  return <section data-section-id="223897" id="the-planning-journey" className="dark bg-background py-24 lg:py-32 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-6 md:px-12 max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-16 md:mb-24 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-default font-bold text-foreground mb-6 tracking-tight">
            The Planning Journey
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-sans">
            A meticulously curated path from your first visit to the final toast, 
            ensuring every detail of your VOW experience is effortless and elegant.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-start">
          {}
          <div className="order-2 lg:order-1 lg:sticky lg:top-32 h-[400px] lg:h-[600px] w-full rounded-md overflow-hidden shadow-2xl bg-muted relative">
            {steps.map((step, i) => <div key={step.id} data-index={i} className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${activeStep === step.id ? "opacity-100 z-10" : "opacity-0 z-0"}`}>
                <img src={step.image} alt={step.title} className="w-full h-full object-cover grayscale-[20%] contrast-[110%]" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>)}
          </div>

          {}
          <div className="order-1 lg:order-2 relative py-4 pl-8 md:pl-12">
            {}
            <div className="absolute left-[11px] md:left-[23px] top-8 bottom-8 w-px border-l-2 border-dashed border-primary/40" />

            <Accordion type="single" defaultValue={steps[0].id} onValueChange={val => {
            if (val) setActiveStep(val);
          }} className="w-full">
              {steps.map((step, i) => <div key={step.id} data-index={i} className="relative mb-8 last:mb-0">
                  {}
                  <div className={`absolute -left-8 md:-left-12 top-4 w-6 h-6 rounded-md border-4 border-background z-10 transition-colors duration-500 ${activeStep === step.id ? "bg-primary shadow-lg" : "bg-muted"}`} />
                  
                  <AccordionItem value={step.id} className="border-b-0 bg-card rounded-md px-6 py-2 shadow-sm transition-all duration-500 data-[state=open]:shadow-xl data-[state=open]:bg-accent/10 border border-transparent data-[state=open]:border-primary/20">
                    <AccordionTrigger className="text-xl md:text-2xl font-default font-medium text-foreground hover:no-underline py-4 tracking-wide">
                      {step.title}
                    </AccordionTrigger>
                    <AccordionContent className="text-base md:text-lg text-muted-foreground font-sans leading-relaxed pb-6 pt-2">
                      {step.description}
                    </AccordionContent>
                  </AccordionItem>
                </div>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}